<template>
    <div class="block-header block-header--has-breadcrumb block-header--has-title mt-10">
        <div class="container">
            <div class="block-header__body">
                <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                    <ol class="breadcrumb__list">
                        <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                        <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                            <a href="/index" class="breadcrumb__item-link">Home</a>
                        </li>
                        <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                            <span class="breadcrumb__item-link">Shopping Cart</span>
                        </li>
                        <li class="breadcrumb__title-safe-area" role="presentation" style="--block-header-title-width:155.425px;"></li>
                    </ol>
                </nav>
                <h1 class="block-header__title">Shopping Cart</h1>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-order-entry"></div>
    </div>

    <div class="container">
        <div class="cart">
            <orderlist></orderlist> 
            <ordercart></ordercart>
        </div>
    </div>

    <div class="block-space block-space--layout--divider-lg"></div>
 
</template>
<script>

import Orderlist from '../orderparts/Orderlist';
import Ordercart from '../orderparts/Ordercart';

export default {
    name: 'Cart',
    components: {
        Orderlist,
        Ordercart
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>